import type {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosResponse,
} from 'axios';

const ENABLE_HTTP_LOGGING_ENVS: Array<string | undefined> = [
  // 'development'
];

export function addLoggingInterceptors(
  client: AxiosInstance,
  clientName: string
) {
  if (!ENABLE_HTTP_LOGGING_ENVS.includes(process.env.NODE_ENV)) return;

  client.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const requestId = Math.random().toString(36).substring(2, 9);
      (config as any)._requestId = requestId;

      const url = `${config.baseURL || ''}${config.url}`;
      const method = config.method?.toUpperCase() || 'UNKNOWN';
      const token = config.headers?.Authorization ? 'Attached' : 'None';

      console.log(
        `[HTTP REQ] [${requestId}] ${clientName} | ${method} ${url}`,
        {
          token,
          ...(config.data ? { body: config.data } : {}),
          ...(config.params ? { params: config.params } : {}),
        }
      );

      return config;
    },
    (error) => {
      console.error(`[HTTP REQ ERROR] ${clientName}`, error);
      return Promise.reject(error);
    }
  );

  client.interceptors.response.use(
    (response: AxiosResponse) => {
      const requestId = (response.config as any)._requestId || 'unknown';
      const url = response.config.url;
      console.log(
        `[HTTP RES] [${requestId}] ${clientName} | ${response.status} ${url}`,
        response.data
      );
      return response;
    },
    (error) => {
      const requestId = (error.config as any)?._requestId || 'unknown';
      const url = error.config?.url;
      const status = error.response?.status || 'UNKNOWN';
      console.error(
        `[HTTP RES ERROR] [${requestId}] ${clientName} | ${status} ${url}`,
        error.response?.data || error.message
      );
      return Promise.reject(error);
    }
  );
}
